var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Npm modules
import JsSIP from 'jssip';
// @ts-expect-error
import DigestAuthentication from 'jssip/lib-es5/DigestAuthentication';
// @ts-expect-error
import RequestSender from 'jssip/lib-es5/RequestSender';
// @ts-expect-error
import SIPMessage from 'jssip/lib-es5/SIPMessage';
// @ts-expect-error
import Transactions from 'jssip/lib-es5/Transactions';
// @ts-expect-error
import parse from 'xml-parser';
// App modules
import { logActivity } from '../helpers/activityLog';
import Call from './Call';
import { stringToUriObject } from './util';
// if (process.env.NODE_ENV === 'production') {
//   JsSIP.debug.disable('*');
// } else {
//   JsSIP.debug.enable('*');
// }
// @ts-expect-error
JsSIP.debug.disable('*');
class UserAgent extends JsSIP.UA {
    constructor(config) {
        const { domain } = config, restConfig = __rest(config, ["domain"]);
        const properConfig = Object.assign({ ws_servers: 'wss://sipws.sipcentric.com', register_expires: 60, session_timers: false, connection_recovery_max_interval: 30, connection_recovery_min_interval: 2 }, restConfig);
        if (config.username) {
            // const uriParts = Utils.normalizeTarget(
            //   `sip:${config.username}@${domain}`,
            //   domain,
            // );
            // config.uri = new URI(
            //   uriParts.scheme,
            //   uriParts.user,
            //   uriParts.host,
            //   uriParts.port,
            // );
            properConfig.uri = `sip:${config.username}@${domain}`;
        }
        if (config.userAgent) {
            // @ts-expect-error
            JsSIP.C.USER_AGENT = config.userAgent;
        }
        properConfig.sockets = [
            new JsSIP.WebSocketInterface(properConfig.ws_servers),
        ];
        const { audio } = config;
        super(properConfig);
        this.isActive = true;
        this.uuid = crypto.randomUUID();
        logActivity(this.uuid, 'CONSTRUCTOR', { uri: properConfig.uri });
        this.uriString = properConfig.uri;
        this.domain = domain;
        this.audio = audio;
        this.ongoingCalls = [];
        this.sessions = {};
        this.subscriptions = new Map();
        this.subscribeExpires = 600;
        this.isActive = true;
        // Resubscribe checker
        setInterval(() => {
            this.subscriptions.forEach((subscription) => {
                const { expires, subscriptionState } = subscription;
                if (subscriptionState === 'expired') {
                    this.subscribe(subscription.toUser, subscription.toDomain, subscription);
                    return;
                }
                const resubscribeTime = 50000;
                const now = Date.now();
                const diff = expires - now;
                if (diff < resubscribeTime) {
                    this.resubscribe(subscription);
                }
            });
        }, 30000);
        this.on('newRTCSession', (e) => {
            if (e.originator === 'remote') {
                const call = new Call(this, 'IN', e.session);
                const sipcentricTags = e.request.headers['X-Sipcentric-Tags'];
                if (sipcentricTags) {
                    const rawTags = sipcentricTags[0].raw;
                    const tags = JSON.parse(rawTags);
                    call.tags = tags;
                }
                this.addOngoingCall(call);
                this.emit('incomingCall', call);
            }
        });
        this.cseq = 0;
        // Rename receiveRequest to _receiveRequest
        // @ts-expect-error
        this._receiveRequest = this.receiveRequest;
        // Define a new receiveRequest handler that checks for NOTIFYs
        // If the request is a NOTIFY it handles it,
        // otherwise it passes the request off to _receiveRequest
        this.receiveRequest = (request) => {
            // If we've got a NOTIFY
            if (request.method === JsSIP.C.NOTIFY &&
                request.headers.Event[0].raw === 'dialog') {
                // JsSIP transaction check
                if (Transactions.checkTransaction(this, request)) {
                    return;
                }
                // This is horrible but required
                new Transactions.NonInviteServerTransaction(this, request.transport, request);
                try {
                    const subscriptionStateHeader = request.headers['Subscription-State'][0].raw;
                    if (subscriptionStateHeader) {
                        const subscriptionState = subscriptionStateHeader.split(';')[0];
                        this.updateSubscriptionState(request);
                        if (subscriptionState === 'terminated') {
                            return;
                        }
                    }
                }
                catch (err) {
                    // console.debug('err: ', err);
                }
                if (!request.body) {
                    return;
                }
                // Parse the xml request body
                const parsedBody = parse(request.body);
                try {
                    // Grab the state and version from the parsed body
                    const state = parsedBody.root.children[0].children[0].content;
                    const version = parseInt(parsedBody.root.attributes.version, 10);
                    // Find the subscription
                    const subscription = this.getSubscription(request);
                    if (subscription) {
                        if (version > subscription.version) {
                            this.updateVersion(request, version);
                            this.emitUserStateChanged(subscription.toUser, state);
                        }
                        // Reply OK
                        request.reply(200);
                    }
                }
                catch (e) {
                    console.debug('Error parsing xml: ', request);
                }
            }
            else {
                // Pass the request off to _receiveRequest
                return this._receiveRequest(request);
            }
        };
    }
    emitUserStateChanged(user, state) {
        let mappedState;
        switch (state) {
            case 'terminated': {
                mappedState = 'ACTIVE';
                break;
            }
            case 'confirmed':
            case 'Trying': {
                mappedState = 'INACTIVE';
                break;
            }
            case 'early': {
                mappedState = 'RINGING';
                break;
            }
            default: {
                mappedState = 'UNKNOWN';
                break;
            }
        }
        if (mappedState) {
            this.emit('userStateChanged', user, mappedState);
        }
    }
    getSubscription(message) {
        return this.subscriptions.get(message.call_id);
    }
    updateVersion(request, version) {
        const subscription = this.getSubscription(request);
        if (subscription) {
            this.subscriptions.set(request.call_id, Object.assign(Object.assign({}, subscription), { version }));
        }
    }
    updateSubscriptionState(request) {
        var _a;
        if (!request.headers['Subscription-State'])
            return;
        const subscriptionStateHeader = request.headers['Subscription-State'][0].raw;
        const splitHeaders = subscriptionStateHeader.split(';');
        const state = splitHeaders[0];
        const secToExpire = (_a = splitHeaders
            .find((x) => x.includes('expires'))) === null || _a === void 0 ? void 0 : _a.split('=')[1];
        const msToExpire = Number(secToExpire) * 1000;
        const subscription = this.getSubscription(request);
        if (subscription) {
            clearTimeout(subscription.expireTimeout);
            this.subscriptions.set(request.call_id, Object.assign(Object.assign({}, subscription), { subscriptionState: state, expires: secToExpire === undefined
                    ? subscription.expires
                    : Date.now() + msToExpire, expireTimeout: setTimeout(() => {
                    this.expireSubscription(request);
                }, msToExpire) }));
        }
    }
    storeSubscription(response) {
        const callId = response.call_id;
        const msToExpire = response.headers.Expires[0].raw * 1000;
        const expires = Date.now() + msToExpire;
        const subscription = this.getSubscription(response);
        const version = subscription ? subscription.version : -1;
        const rawContact = response.headers.Contact[0].raw;
        const contact = rawContact.replace(/[<,>]/g, '');
        if (subscription && subscription.hasOwnProperty('expireTimeout')) {
            clearTimeout(subscription.expireTimeout);
        }
        this.subscriptions.set(callId, {
            callId,
            version,
            expires,
            contact,
            toUser: response.to.uri.user,
            toDomain: response.to.uri.host,
            cseq: response.cseq,
            toTag: response.to_tag,
            fromTag: response.from_tag,
            expireTimeout: setTimeout(() => {
                this.expireSubscription(response);
            }, msToExpire),
        });
    }
    expireSubscription(response) {
        const callId = response.call_id;
        const subscription = this.getSubscription(response);
        if (subscription) {
            this.subscriptions.set(callId, Object.assign(Object.assign({}, subscription), { subscriptionState: 'expired' }));
        }
    }
    clearSubscriptions() {
        this.subscriptions.forEach((subscription) => {
            const { expireTimeout } = subscription;
            clearTimeout(expireTimeout);
        });
        this.subscriptions.clear();
    }
    connect() {
        return this.start();
    }
    subscribe(user, domain, replacesSubscription) {
        if (!this.isConnected()) {
            return;
        }
        const { Utils } = JsSIP;
        let extraHeaders = [];
        extraHeaders = extraHeaders.slice();
        extraHeaders.push(`Contact: ${this.contact.toString()}; expires=${this.subscribeExpires}`);
        extraHeaders.push(`Expires: ${this.subscribeExpires}`);
        extraHeaders.push('Event: dialog');
        const uri = stringToUriObject(`sip:${user}@${domain}`, this);
        let callId;
        if (replacesSubscription) {
            callId = replacesSubscription.callId;
        }
        else {
            // @ts-expect-error
            callId = Utils.createRandomToken(22);
        }
        const request = new SIPMessage.OutgoingRequest(JsSIP.C.SUBSCRIBE, uri, this, {
            to_uri: uri,
            call_id: callId,
            cseq: 1,
        }, extraHeaders);
        const requestSender = new RequestSender(this, request, {
            onReceiveResponse: this.subscribeResponseHandler.bind(this),
            onRequestTimeout: () => {
                console.debug('timeout');
            },
            onTransportError: () => {
                console.debug('transport error');
            },
        });
        requestSender.send();
    }
    resubscribe(subscription) {
        if (!this.isConnected()) {
            return;
        }
        let extraHeaders = [];
        extraHeaders = extraHeaders.slice();
        extraHeaders.push(`Contact: ${this.contact.toString()}; expires=${this.subscribeExpires}`);
        extraHeaders.push(`Expires: ${this.subscribeExpires}`);
        extraHeaders.push('Event: dialog');
        const uri = stringToUriObject(`sip:${subscription.toUser}@${subscription.toDomain}`, this);
        const contactUri = stringToUriObject(subscription.contact, this);
        const request = new SIPMessage.OutgoingRequest(JsSIP.C.SUBSCRIBE, contactUri, this, {
            to_uri: uri,
            call_id: subscription.callId,
            cseq: subscription.cseq + 1,
            from_tag: subscription.fromTag,
            to_tag: subscription.toTag,
        }, extraHeaders);
        const requestSender = new RequestSender(this, request, {
            onReceiveResponse: this.subscribeResponseHandler.bind(this),
            onRequestTimeout: () => {
                console.debug('timeout');
            },
            onTransportError: () => {
                console.debug('transport error');
            },
        });
        requestSender.send();
    }
    subscribeResponseHandler(response) {
        let challenge;
        let authorizationHeaderName;
        const statusCode = response.status_code;
        /*
         * Authentication
         * Authenticate once. _challenged_ flag used to avoid infinite authentications.
         */
        if ((statusCode === 401 || statusCode === 407) &&
            (this.configuration.password !== null ||
                this.configuration.ha1 !== null)) {
            // Get and parse the appropriate WWW-Authenticate or Proxy-Authenticate header.
            if (response.statusCode === 401) {
                challenge = response.parseHeader('www-authenticate');
                authorizationHeaderName = 'authorization';
            }
            else {
                challenge = response.parseHeader('proxy-authenticate');
                authorizationHeaderName = 'proxy-authorization';
            }
            // Verify it seems a valid challenge.
            if (!challenge) {
                console.debug(`${response.statusCode} with wrong or missing challenge, cannot authenticate`);
                return;
            }
            if (!this.challenged ||
                (!this.staled && challenge.stale === true)) {
                if (!this.auth) {
                    this.auth = new DigestAuthentication({
                        username: this.configuration.authorization_user,
                        password: this.configuration.password,
                        realm: this.configuration.realm,
                        ha1: this.configuration.ha1,
                    });
                }
                // Verify that the challenge is really valid.
                if (!this.auth.authenticate(this.request, challenge)) {
                    return;
                }
                this.challenged = true;
                // Update ha1 and realm in the this.
                this.set('realm', this.auth.get('realm'));
                this.set('ha1', this.auth.get('ha1'));
                if (challenge.stale) {
                    this.staled = true;
                }
                this.request = this.request.clone();
                this.request.cseq = response.cseq + 1;
                this.request.setHeader(`cseq ${this.request.cseq} ${this.method}`);
                this.request.setHeader(authorizationHeaderName, this.auth.toString());
                this.send();
            }
        }
        else if (statusCode.toString().match(/20\d/)) {
            this.storeSubscription(response);
        }
    }
    dial(target, options) {
        // Before setting up the call, place
        // all other calls on hold
        this.ongoingCalls.forEach((call) => {
            if (!call.isOnHold) {
                call.hold();
            }
        });
        return new Call(this, 'OUT', target, options);
    }
    addOngoingCall(call) {
        const callExists = !!this.getOngoingCall(call.session.id);
        logActivity(this.uuid, 'ONGOING_ADD', {
            direction: call.direction,
            sessionId: call.session.id,
            ongoingCallIds: this.ongoingCalls.map((call) => call.session.id),
            callExists,
        });
        if (!callExists) {
            this.ongoingCalls.push(call);
        }
    }
    removeOngoingCall(sessionId) {
        logActivity(this.uuid, 'ONGOING_REMOVE', {
            sessionId,
            ongoingCallIds: this.ongoingCalls.map((call) => call.session.id),
        });
        this.ongoingCalls = this.ongoingCalls.filter((c) => c.session.id !== sessionId);
    }
    getOngoingCall(sessionId) {
        return this.ongoingCalls.find((c) => c.session.id === sessionId);
    }
    getActiveCall() {
        return this.ongoingCalls.find((c) => !c.isOnHold);
    }
    setVolume(volume) {
        if (!this.audio.remote) {
            return;
        }
        this.audio.remote.volume = volume;
    }
}
export default UserAgent;
